import { render, staticRenderFns } from "./CodelessComponent.vue?vue&type=template&id=76422284"
import script from "./CodelessComponent.vue?vue&type=script&lang=ts"
export * from "./CodelessComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports